import MasterdataTemplateMainView from "@/components/Sections/Masterdata/Template/Main.vue"

const router = {
    path: 'template',
    component: MasterdataTemplateMainView,
}

export default router